import React, { useEffect, useState } from 'react';
import { Mail, FileText, MessageSquareText, Activity } from 'lucide-react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api';

const Card = ({ icon: Ic, label, value, hint, to }) => (
  <Link to={to} className="block bg-bg-secondary border border-line rounded-md p-6 hover:border-acid/40 transition-colors group" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, '-')}`}>
    <div className="flex items-start justify-between mb-6">
      <div className="w-10 h-10 rounded-md border border-line flex items-center justify-center text-acid group-hover:border-acid transition-colors">
        <Ic size={18} />
      </div>
      <span className="text-eyebrow text-ink-dim group-hover:text-ink transition-colors">→</span>
    </div>
    <div className="font-display text-5xl text-ink leading-none mb-2">{value}</div>
    <div className="text-eyebrow text-ink-muted">{label}</div>
    {hint && <div className="text-xs text-ink-dim mt-2">{hint}</div>}
  </Link>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState({ leads_total: 0, leads_new: 0, content_sections: 0 });
  useEffect(() => {
    api.get('/admin/stats').then(({ data }) => setStats(data)).catch(() => {});
  }, []);
  return (
    <div data-testid="admin-dashboard">
      <header className="mb-10">
        <p className="text-eyebrow text-ink-muted mb-2">Panel de control</p>
        <h1 className="font-display text-5xl md:text-6xl text-ink leading-tight">Bienvenida, Admin.</h1>
        <p className="text-ink-muted mt-3 max-w-xl">Edita cualquier sección de la web, revisa los leads recibidos y configura el envío de emails. Todos los cambios se publican al instante.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-10">
        <Card icon={Mail} label="Leads totales" value={stats.leads_total} to="/admin/leads" />
        <Card icon={Activity} label="Leads nuevos" value={stats.leads_new} hint="Sin gestionar" to="/admin/leads" />
        <Card icon={FileText} label="Secciones CMS" value={stats.content_sections} to="/admin/content/hero" />
      </div>

      <div className="bg-bg-secondary border border-line rounded-md p-8">
        <p className="text-eyebrow text-ink-muted mb-4">Empieza por aquí</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link to="/admin/content/intro_hero" className="border border-line p-5 rounded-md hover:border-acid/40 transition" data-testid="quick-edit-hero">
            <div className="font-display text-2xl text-ink mb-1">Editar Intro / Hero</div>
            <div className="text-sm text-ink-muted">Título, próximo drop, CTAs e imagen principal</div>
          </Link>
          <Link to="/admin/content/looks_hall_of_fame" className="border border-line p-5 rounded-md hover:border-acid/40 transition" data-testid="quick-edit-pricing">
            <div className="font-display text-2xl text-ink mb-1">Looks Hall of Fame</div>
            <div className="text-sm text-ink-muted">Las colecciones con hover de imagen</div>
          </Link>
          <Link to="/admin/settings/smtp" className="border border-line p-5 rounded-md hover:border-acid/40 transition" data-testid="quick-edit-smtp">
            <div className="font-display text-2xl text-ink mb-1">Conectar SMTP</div>
            <div className="text-sm text-ink-muted">Para que los leads lleguen a tu email</div>
          </Link>
          <Link to="/admin/leads" className="border border-line p-5 rounded-md hover:border-acid/40 transition" data-testid="quick-leads">
            <div className="font-display text-2xl text-ink mb-1">Ver leads</div>
            <div className="text-sm text-ink-muted">Bandeja con búsqueda y export CSV</div>
          </Link>
        </div>
      </div>
    </div>
  );
}
